/**
 * Pin the original (interactive) thead to the page while keeping its native
 * horizontal scroll and column sizing. A translated thead avoids cloning the
 * select-all checkbox or changing page flow inside the horizontal scroller.
 */
export function bindInventoryReplenishmentStickyHeader(root: HTMLElement): () => void {
  const main = root.querySelector<HTMLElement>(".has-sticky-replenishment");
  const heading = main?.querySelector<HTMLElement>(".inventory-transfer-sticky-head");
  const table = main?.querySelector<HTMLTableElement>(".inventory-replenishment-table");
  const thead = table?.tHead;
  if (!main || !heading || !table || !thead) return () => {};
  const topbar = root.querySelector<HTMLElement>(".topbar");
  let frame = 0;
  let disposed = false;
  const update = (): void => {
    frame = 0;
    if (disposed || !main.isConnected) return;
    const top = Math.max(0, topbar?.getBoundingClientRect().bottom ?? 0);
    main.style.setProperty("--inventory-page-top", `${top}px`);
    const tableBox = table.getBoundingClientRect();
    const offset = Math.max(0, Math.min(
      heading.getBoundingClientRect().bottom - tableBox.top,
      tableBox.height - thead.getBoundingClientRect().height,
    ));
    thead.style.transform = `translateY(${offset}px)`;
  };
  const schedule = (): void => {
    if (!frame && !disposed) frame = requestAnimationFrame(update);
  };
  const observer = new ResizeObserver(schedule);
  for (const element of [topbar, heading, table]) if (element) observer.observe(element);
  window.addEventListener("scroll", schedule, { passive: true });
  window.addEventListener("resize", schedule, { passive: true });
  update();
  return () => {
    disposed = true;
    cancelAnimationFrame(frame);
    observer.disconnect();
    window.removeEventListener("scroll", schedule);
    window.removeEventListener("resize", schedule);
    thead.style.removeProperty("transform");
    main.style.removeProperty("--inventory-page-top");
  };
}
